import { InfoCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { tran } from '../../../../translations/schema/TranslationSchema';
import type { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { IInfoWidget } from './IInfoWidget';
import { InfoWidgetComponent } from './InfoWidgetComponent';
import {
  InfoWidgetConfigComponent,
  InfoWidgetConfigSchema,
} from './InfoWidgetConfigComponent';

/**
 * Tipo del componente di visualizzazione di un box informativo.
 */
export const InfoWidgetType: IWidgetType<IInfoWidget> = {
  icon: <InfoCircleOutlined />,
  type: WidgetType.Info,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Box informativo',
  hasValue: false,
  formComponent: InfoWidgetComponent,
  configComponent: InfoWidgetConfigComponent,
  configValidator: InfoWidgetConfigSchema,
  previewComponent: InfoWidgetComponent,
  translationSchema: tran.widget({
    body: tran.rte(),
    layout: tran.object({
      collapsibleBody: tran.rte(),
      collapsibleExpandText: tran.string(),
      collapsibleCollapseText: tran.string(),
    }),
  }),
  rules: [],
};
